import axios from 'axios'

const http = axios.create({ baseURL: '/api', timeout: 60000 })

http.interceptors.request.use(config => {
  const token = localStorage.getItem('token')
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})

http.interceptors.response.use(
  res => res.data,
  err => {
    if (err.response && err.response.status === 401) {
      localStorage.removeItem('token')
      window.location.href = '/login'
    }
    return Promise.reject(err)
  }
)

function buildQuery(params) {
  const sp = new URLSearchParams()
  Object.entries(params || {}).forEach(([k, v]) => {
    if (v === undefined || v === null || v === '') return
    sp.append(k, v)
  })
  return sp.toString()
}

export default {
  // Channels
  listChannels() { return http.get('/printing/channels') },
  channelLogin(channelCode) { return http.post(`/printing/channels/${channelCode}/login`) },

  // Orders
  listOrders(params) { return http.get('/printing/orders', { params }) },
  getOrder(id) { return http.get(`/printing/orders/${id}`) },
  getStats(params) { return http.get('/printing/orders/stats', { params }) },
  syncOrders(payload) { return http.post('/printing/orders/sync', payload) },
  createOrder(payload) { return http.post('/printing/orders', payload) },
  updateOrder(id, payload) { return http.put(`/printing/orders/${id}`, payload) },
  deleteOrders(ids) { return http.delete('/printing/orders', { data: { ids } }) },
  copyOrders(ids) { return http.post('/printing/orders/copy', { ids }) },
  checkPrintLabel(payload) { return http.post('/printing/orders/check-print', payload) },

  // PDF / export URLs (window.open friendly)
  printLabelUrl(params) {
    const token = localStorage.getItem('token') || ''
    const qs = buildQuery({ ...params, token })
    return `/api/printing/orders/print?${qs}`
  },
  exportOrdersUrl(params) {
    const token = localStorage.getItem('token') || ''
    const qs = buildQuery({ ...params, token })
    return `/api/printing/orders/export?${qs}`
  },

  // Imports (multipart)
  importOrders(channelCode, status, file) {
    const fd = new FormData()
    fd.append('file', file)
    return http.post(`/printing/orders/import?channel_code=${encodeURIComponent(channelCode)}&status=${encodeURIComponent(status || 'Draft')}`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  },
  importWeight(channelCode, file) {
    const fd = new FormData()
    fd.append('file', file)
    return http.post(`/printing/orders/import-weight?channel_code=${encodeURIComponent(channelCode)}`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  },
  importModify(channelCode, file) {
    const fd = new FormData()
    fd.append('file', file)
    return http.post(`/printing/orders/import-modify?channel_code=${encodeURIComponent(channelCode)}`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  }
}